import { useMemo } from 'react';

import { useMembersListQuery } from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

import { CredentialCategory } from '../types';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function useMemberOptions(category: CredentialCategory) {
  const { data, isLoading, error } = useMembersListQuery(
    {},
    {
      skip: category === 'Misc' || category === 'Vehicle',
    }
  );

  const options = useMemo<SelectOption[]>(
    () =>
      data?.results.map((member) => ({
        value: member.id,
        label: formatFullName(member),
      })) ?? [],
    [data]
  );

  return {
    options,
    isLoading,
    error,
  };
}
